import React, { createContext, useContext, useState, useCallback } from "react";
import RateLimitDialog from "../components/dialogs/RateLimitDialog";

const RateLimitContext = createContext(null);

/**
 * Provider that manages the rate limit dialog state globally.
 * Wrap your app with this provider to enable showing the rate limit dialog
 * from anywhere (e.g., from the API client when a 429 error occurs).
 */
export const RateLimitProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const showRateLimitDialog = useCallback(() => {
    setOpen(true);
  }, []);

  const hideRateLimitDialog = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <RateLimitContext.Provider
      value={{ showRateLimitDialog, hideRateLimitDialog }}
    >
      {children}
      <RateLimitDialog open={open} onClose={hideRateLimitDialog} />
    </RateLimitContext.Provider>
  );
};

/**
 * Hook to access the rate limit dialog functions.
 * Call `showRateLimitDialog()` to display the dialog (e.g., on 429 error).
 */
export const useRateLimitDialog = () => {
  const context = useContext(RateLimitContext);
  if (!context) {
    throw new Error(
      "useRateLimitDialog must be used within a RateLimitProvider",
    );
  }
  return context;
};

export default RateLimitContext;
